import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import InsumoForm from "../Components/insumoForm/insumoForm";
import { useAuth } from "../Context/auth";
import './Insumos.css';

function NovoInsumo() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [codigoCarregado, setCodigoCarregado] = useState(false);

    useEffect(() => {
        if (!currentUser) return;
        const gerarProximoCodigo = async () => {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/insumos/next-code`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Falha ao gerar código.');
                const data = await response.json();
                setInitialData({ codigo: data.nextCode });
            } catch (error) {
                console.error("Erro ao gerar próximo código:", error);
                setInitialData({ codigo: '1' });
            } finally {
                setCodigoCarregado(true);
            }
        };
        gerarProximoCodigo();
    }, [currentUser]);

    async function handleCadastrar(formData) {
        if (!formData.codigo || !formData.descricao) {
            setMensagem('Código e Descrição são obrigatórios.');
            return;
        }
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/insumos`, {
                method: 'POST',
                confirmButtonColor: '#2185c6',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao cadastrar insumo.");
            }
            navigate('/app/insumos');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="insumos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="insumos-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/insumos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="insumos-title m-0">
                            Cadastrar <span className="highlight">Insumo</span>
                        </h1>
                    </div>
                </div>

                <main className="insumos-content">
                    {mensagem && (
                        <div className="alert alert-danger mb-4 d-flex align-items-center">
                            <i className="fas fa-exclamation-circle me-2"></i> {mensagem}
                        </div>
                    )}

                    {codigoCarregado ? (
                        <InsumoForm
                            initialData={initialData}
                            onSubmit={handleCadastrar}
                            loading={loading}
                        />
                    ) : (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2 text-muted">Gerando código...</p>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}

export default NovoInsumo;